import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './index.css'
import { applyBrand, brand } from './brand'

// Apply active-brand accent tokens (VITE_BRAND) before first paint.
applyBrand()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1F2937',
          color: '#FFFFFF',
          border: '1px solid #374151',
        },
        success: {
          iconTheme: {
            primary: brand?.colors?.accent || '#D4AF37',
            secondary: '#FFFFFF',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#FFFFFF',
          },
        },
      }}
    />
    <App />
  </React.StrictMode>,
)
